export enum RequiredDataStep {
    Step1 = '/step1',
    Step2 = '/step2',
    Step3 = '/step3',
    Step4 = '/step4',
    Step5 = '/step5',
    Step6 = '/step6',
    Step7 = '/profile',
}
